import { render, staticRenderFns } from "./EntityDetailedCardView.vue?vue&type=template&id=436c426c&scoped=true"
import script from "./EntityDetailedCardView.vue?vue&type=script&lang=js"
export * from "./EntityDetailedCardView.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailedCardView.vue?vue&type=style&index=0&id=436c426c&prod&lang=scss&scoped=true"
import style1 from "./EntityDetailedCardView.vue?vue&type=style&index=1&id=436c426c&prod&lang=css"
import style2 from "./EntityDetailedCardView.vue?vue&type=style&index=2&id=436c426c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c426c",
  null
  
)

export default component.exports